package com.milta.core.localization.translations.de

import com.milta.core.localization.PackageLabelScanStrings

internal val PackageLabelScan = PackageLabelScanStrings(
    scanTitle = "Etikett scannen",
    analysingTitle = "Etikett wird gelesen…",
    analysingSubtitle = "Wir suchen nach Name, Adresse und Telefonnummer des Empfängers. Das dauert nur wenige Sekunden.",
    reviewTitle = "Zustellung bestätigen",
    deliveryDetectedLabel = "Zustellung erkannt",
    allReadableLabel = "Alles lesbar",
    fieldToCompleteSingularSuffix = "Feld zu vervollständigen",
    fieldToCompletePluralSuffix = "Felder zu vervollständigen",
    recipientNotDetectedValue = "Nicht erkannt",
    addressNotDetectedValue = "Nicht erkannt",
    phoneNotDetectedValue = "Nicht erkannt",
    fieldRequiredWarning = "Pflichtfeld zum Hinzufügen der Zustellung",
    recipientCorrectionPlaceholder = "Empfänger eingeben…",
    addressCorrectionPlaceholder = "Adresse eingeben…",
    unreadableTitle = "Etikett nicht lesbar.",
    unreadableMessage = "Machen Sie ein Foto, das auf das Etikett ausgerichtet, gut beleuchtet und ohne Blendung ist.",
    maxAttemptsMessage = "Vervollständigen Sie diese Zustellung manuell, oder starten Sie den Scan mit einem neuen Foto neu.",
)
